import {stores} from "../../stores";
import {_toCurrencyWithP} from "../../components/currency-component/CurrencyClasses";

/**
 * An amount in the compact, locale-aware format of `CurrencyComponent` (e.g. "R$ 178M"), for places that need a
 * string: ECharts axes, labels and tooltips.
 */
export const sitMoney = (v: number | string | null | undefined): string =>
    _toCurrencyWithP(Number(v) || 0, stores.p.currencyFormat, stores.p.currencySymbol, undefined, 3)[0];
